import { render, staticRenderFns } from "./MainNavBar.vue?vue&type=template&id=06cd6660&scoped=true&"
import script from "./MainNavBar.vue?vue&type=script&lang=ts&"
export * from "./MainNavBar.vue?vue&type=script&lang=ts&"
import style0 from "./MainNavBar.vue?vue&type=style&index=0&id=06cd6660&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06cd6660",
  null
  
)

export default component.exports